import { gql } from "@apollo/client";export default gql`mutation deleteUser($id: Int!) {
  deleteUser: delete_user_by_pk(id: $id) {
    id
  }
}
`;
